define(() => {
    "use strict";

    /**
     * Captures mouse position within the context of a DOM element.
     */

    const Mouse = {};

    Mouse.x = 0;
    Mouse.y = 0;

    // Set to false since we do not support touch event for now.
    Mouse.isTouchSupported = false;
    Mouse.START = Mouse.isTouchSupported ? "touchstart" : "mousedown";
    Mouse.MOVE = Mouse.isTouchSupported ? "touchmove" : "mousemove";
    Mouse.END = Mouse.isTouchSupported ? "touchend" : "mouseup";

    Mouse.get = (event, elem) => {
        if (!elem) {
            elem = event.currentTarget;
        }

        if (event.touches) {
            if (event.touches.length) {
                Mouse.x = parseInt(event.touches[0].pageX, 10);
                Mouse.y = parseInt(event.touches[0].pageY, 10);
            }
        } else {
            // mouse events
            Mouse.x = parseInt(event.clientX, 10);
            Mouse.y = parseInt(event.clientY, 10);
        }

        const rect = elem.getBoundingClientRect();
        Mouse.x += elem.scrollLeft - elem.clientLeft - rect.left;
        Mouse.y += elem.scrollTop - elem.clientTop - rect.top;

        return this;
    };

    return Mouse;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/transformations/Mouse.js